import * as R from 'ramda';

import { WeeklyTimeSpan } from 'apis/restaurant-api/merchant-admin/menu2/types';

import {
  entriesToWeeklyTimePairs,
  mergeConnectedTimePairs,
  WeeklyTimePair,
} from './fromWeeklyScheduleInputEntriesToWeeklySchedule';
import { WeeklyScheduleInputEntry } from './types';

const DAY_DURATION_MIN = 24 * 60;
const WEEK_DURATION_MIN = DAY_DURATION_MIN * 7;

export const weeklyTimePairsToWeeklyTimeSpans = (weeklyTimePairs: WeeklyTimePair[]): WeeklyTimeSpan[] => {
  return weeklyTimePairs
    .map(timePair => {
      const startMinutes = timePair.start / (60 * 1000);
      const endMinutes = timePair.end / (60 * 1000);

      // If end is at exactly midnight on Sunday
      if (startMinutes > endMinutes && endMinutes === 0) {
        return {
          start: startMinutes,
          end: WEEK_DURATION_MIN,
        };
      }

      // Sunday-Monday overlapping time pair
      if (startMinutes > endMinutes) {
        return [
          {
            start: 0,
            end: endMinutes,
          },
          {
            start: startMinutes,
            end: WEEK_DURATION_MIN,
          },
        ];
      }

      return {
        start: startMinutes,
        end: endMinutes,
      };
    })
    .flat()
    .sort((a, b) => a.start - b.start);
};

const checkFullTimeSpanDuration = (timeSpans: WeeklyTimeSpan[]): WeeklyTimeSpan[] => {
  const fullDuration = timeSpans.reduce((acc, timeSpan) => {
    return acc + (timeSpan.end - timeSpan.start);
  }, 0);

  if (fullDuration === WEEK_DURATION_MIN || fullDuration === 0) {
    return [];
  }

  return timeSpans;
};

const fromWeeklyScheduleInputEntriesToWeeklyTimeSpans: (
  weeklyScheduleInputEntries: WeeklyScheduleInputEntry[],
) => WeeklyTimeSpan[] = R.pipe(
  entriesToWeeklyTimePairs,
  mergeConnectedTimePairs,
  weeklyTimePairsToWeeklyTimeSpans,
  checkFullTimeSpanDuration,
);

export default fromWeeklyScheduleInputEntriesToWeeklyTimeSpans;
